const PrivacyContents = () => (
    <iframe src="https://plip.kr/pcc/80d8d52b-2356-405c-9028-db0e566cf891/privacy/1.html" style={{display: "block", width: "100vw", height: "100vh"}} sandbox=""/>
);

export default PrivacyContents;